// Minimal cookie reader (browser-only). Used by authStore to read the
// non-httpOnly csrf cookie set by the backend.
export function readCookie(name) {
  if (typeof document === "undefined") return null;
  const target = `${name}=`;
  const parts = document.cookie.split("; ");
  for (const part of parts) {
    if (part.startsWith(target)) {
      try {
        return decodeURIComponent(part.slice(target.length));
      } catch (_) {
        return part.slice(target.length);
      }
    }
  }
  return null;
}

export default { readCookie };
